import React, { useRef, useEffect } from "react";
import Dialog from "src/components/common/Dialog";

interface ViewSentCardsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  previewUrl: string | null;
  isLoading: boolean;
}

const ViewSentCardsDialog: React.FC<ViewSentCardsDialogProps> = ({
  isOpen,
  onClose,
  previewUrl,
  isLoading,
}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    console.log("ViewSentCardsDialog previewUrl:", previewUrl);

    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== process.env.REACT_APP_INKED_APP_URL) return;

      const { type } = event.data;

      switch (type) {
        case "CANCEL_CLICK":
        case "CLOSE_CLICK":
          onClose();
          break;
        default:
          break;
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [isOpen, onClose, previewUrl]);

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={(open) => !open && onClose()}
      title=""
      className="view-sent-cards-dialog !max-w-[1000px] !w-[95vw] md:!w-[1000px]"
    >
      <div className="w-full" style={{ height: "75vh" }}>
        {isLoading ? (
          <div className="w-full h-full flex items-center justify-center">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
              <p>Loading card previews...</p>
            </div>
          </div>
        ) : previewUrl ? (
          <iframe
            ref={iframeRef}
            src={previewUrl}
            className="w-full h-full border-0 rounded-lg"
            title="Card Previews"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <p className="text-gray-secondary">Unable to load card previews</p>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ViewSentCardsDialog;
